import { ViewRouteConfig } from '@scoring-web/configs/route/route.type';
import assessmentDetailRoute from '@scoring-web/modules/assessment/views/detail/assessment-detail.route';
import assessmentListRoute from '@scoring-web/modules/assessment/views/list/assessment-list.route';
import loginRoute from '@scoring-web/modules/user/views/login/login.route';
import MainErrorView from './main.error-view';
import MainView from './main.view';

const mainRoute: ViewRouteConfig = {
  children: [loginRoute, assessmentListRoute, assessmentDetailRoute],
  Component: MainView,
  ErrorBoundary: MainErrorView,
  path: '/',
};

export default mainRoute;
